export const phoneUseValues = {
    mobile: 'Mobile',
    home: 'Home',
    work: 'Work',
    fax: 'Fax',
};

export const emailUseIcon = {
    home: 'at',
    work: 'briefcase',
};

export const emailUseTextValues = {
    home: 'Personal',
    work: 'Work',
};

export const addressUseIcon = {
    home: 'home',
    work: 'building',
    billing: 'mailbox',
};

export const addressUseValues = {
    home: 'Home',
    work: 'Work',
    billing: 'Mailing',
};

export function getPhoneIcon(phone) {
    if (phone?.system === 'fax' || phone?.use === 'fax') return 'fax';
    if (phone?.use === 'work') return 'phone-office';
    if (phone?.use === 'mobile') return 'mobile';
    if (phone?.use === 'home') return 'phone-rotary';
    return 'phone';
}
